export const SOFTLINE_PERMISSION_GESAMTABFRAGE = 'GESAMTABFRAGE';
